<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <s-select-generic ref="sDsitrict"
      autocomplete class="text"
      itemtext="GenDescription"
      itemvalue="GenHelper" 
      :disabled="disabled"
      id="GenDescription"
      :value="value"
      :return-object="returnObject"
      @input="input($event)" 
      :config="config" 
      :label="label"
      :full="full" 
      :autofocus="autofocus"
      :text="text" 
      :clearable="clearable" 
      :noDefault="noDefault"
      @change="change($event)"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sGenericService from "./../../services/General/GenericService";
export default {
  props: {
    autofocus: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    value: null, // AGREGAR ESTA PROP
    text: { type: String, default: "" },
    label: { type: String, default: "" },
    returnObject: { type: Boolean, default: false },
    noDefault: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
    ProvinceUbigeo: { type: String, default: "" },
    SearchText: { type: String, default: "" }
  },
  watch: {
    value(newValue) {
      this.item = newValue;
    },
    ProvinceUbigeo(newVal) {
      // Limpiar el valor cuando cambia la provincia
      this.$emit("input", "");
      this.config.params.DistrictUbigeo = newVal;
      this.config.params.SearchText = this.SearchText;
    }
  },
  methods: {
    change(items) {
      this.$emit('change', items)
    },
    focus() {
      this.$refs.sDsitrict.focus();
    },
    input(val) {
      this.$emit("input", val);
    },
  },
  data: () => ({
    item: 0,
    val: '',
    items: [],
    config: {},
  }),
  created() {
    this.config = {
      title: "Distrito",
      url: _sGenericService.getDistrict(),
      params: { 
        DistrictUbigeo: this.ProvinceUbigeo,
        requestID: this.$fun.getUserID(), 
        SearchText: this.SearchText
      },
    };
  }
}
</script>